/** Panel for the Review tab's Radix dropdown menus; items and labels use `@/ui/menu-classes`. */
export const MENU_CONTENT =
  'z-50 min-w-52 flex flex-col gap-0.5 rounded-xl border border-line-strong bg-surface-2 p-1.5 shadow-menu';
